// import Splide JS
import Splide from "@splidejs/splide";
import '@splidejs/splide/css';

export default function initSplide() {
  // Mvセクションのスライドショー
  initMvSplide();
  initCommonSplide();
}
// ----------------------------------------
// メインビジュアル
// ----------------------------------------

function initMvSplide() {
  const splideElements = document.querySelectorAll(".hm-mv-slider");

  if (splideElements.length > 0) {
    splideElements.forEach(function (splideElement, sliderIndex) {

      const splide = new Splide(splideElement, {
        type: "slide",
        rewind: true,
        autoplay: true,
        interval: 5000,
        speed: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false,
        pagination: false,
        drag: false,
      });

      const bgGradients = [
        { after: 'linear-gradient(140deg, rgba(255, 255, 255, 1) 0%, rgba(177,78,196,0) 50%, rgba(177,78,196,0.7) 95%)',
          before: 'linear-gradient(140deg, rgba(255, 255, 255, 1) 0%, rgba(177,78,196,0) 50%, rgba(177,78,196,0.7) 95%)' },
        { after: 'linear-gradient(140deg, rgba(255, 255, 255, 1) 0%, rgba(255,0,102,0) 50%, rgba(255,178,5,0.7) 95%)',
          before: 'linear-gradient(140deg, rgba(255, 255, 255, 1) 0%, rgba(255,0,102,0) 45%, rgba(255,178,5,0.7) 95%)' },
        { after: 'linear-gradient(140deg, rgba(255, 255, 255, 1) 0%, rgba(43,129,203,0) 50%, rgba(43,129,203,0.7) 95%)',
          before: 'linear-gradient(140deg, rgba(255, 255, 255, 1) 0%, rgba(43,129,203,0) 50%, rgba(43,129,203,0.7) 95%)' },
        { after: 'linear-gradient(140deg, rgba(255, 255, 255, 1) 0%, rgba(53,172,53,0) 50%, rgba(53,172,53,0.7) 95%)',
          before: 'linear-gradient(140deg, rgba(255, 255, 255, 1) 0%, rgba(53,172,53,0) 50%, rgba(53,172,53,0.7) 95%)' }
      ];

      // スライダーごとの初期オフセット
      let initialOffset = 0;
      if (sliderIndex === 0) initialOffset = bgGradients.length - 1;
      else if (sliderIndex === 1) initialOffset = 0;
      else if (sliderIndex === 2) initialOffset = 1;

      const updateBg = (slideIndex) => {
        const index = (initialOffset + slideIndex) % bgGradients.length;
        const g = bgGradients[index];
        splideElement.style.setProperty('--mv-bg', g.after);
        splideElement.style.setProperty('--mv-bg-before', g.before);
      };

      splide.on('mounted', function () {
        const slides = splide.Components.Slides.get();
        const slideCount = slides.length;

        // 初期背景色
        updateBg(splide.index);

        slides.forEach(function (slide, index) {
          slide.slide.style.zIndex = slideCount - index;

          slide.slide.addEventListener('animationend', function () {
            this.classList.remove('is-sliding-out');
            this.style.transform = '';

            const currentZIndex = parseInt(this.style.zIndex, 10);
            slides.forEach(s => {
              const z = parseInt(s.slide.style.zIndex, 10);
              if (!isNaN(z) && z < currentZIndex) {
                s.slide.style.zIndex = z + 1;
              }
            });
            
            this.style.zIndex = 1;
          });
        });

        splide.on('move', function (newIndex, oldIndex) {
          const oldSlide = slides[oldIndex]?.slide;
          if (oldSlide) {
            oldSlide.style.zIndex = slideCount + 1;
            oldSlide.classList.add('is-sliding-out');
          }

          // 初期オフセットを保持したまま更新
          updateBg(newIndex);
        });
      });
      
      splide.mount();
    });
  }
}



function initCommonSplide() {
    // hm-mv-sliderクラスを持つ要素をすべて取得
let splideElements = document.querySelectorAll(".p-block-slide");

if (splideElements.length > 0) {
  splideElements.forEach(function(splideElement) {
    let splide = new Splide(splideElement, {
      autoplay   : true,   // 自動再生ON
      interval   : 3000,   // 3秒ごとに切り替え
      speed      : 1000,   // スライダーの移動時間
      pauseOnHover: false, // マウスホバーで一時停止
      pauseOnFocus: false, // フォーカス時に停止しない
      type       : "loop", // スライドをループさせる
      perPage    : 1,      // 1件表示
      perMove    : 1,      // 1枚ずつスライド
      gap        : '20px',      // スライド間の余白
      arrows     : false,  // 前後の矢印を非表示
      pagination : true,  // ページネーション（ドット）非表示
    });

    splide.mount();
  });
}

}
